export const FALL_BACK_DOCUMENT = 'error';
